import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

function Footer() {
    return (
        <footer className="footer fade-in-up" style={{ animationDelay: '0.2s' }}>
            <div className="container footer-content">
                <p className="footer-copyright">
                    © {new Date().getFullYear()} Realtime Polls. All rights reserved.
                </p>
                <nav className="footer-links">
                    <Link to="/legal">Legal & Privacy</Link>
                </nav>
            </div>
        </footer>
    )
}

export default Footer
